__turbopack_context__.v({
  "caption": "FundraiserChart-module-scss-module__cpSkLa__caption",
  "graphWrapper": "FundraiserChart-module-scss-module__cpSkLa__graphWrapper",
  "header": "FundraiserChart-module-scss-module__cpSkLa__header",
  "wrapper": "FundraiserChart-module-scss-module__cpSkLa__wrapper",
});
